import type { ElementRef } from '@angular/core';
import {
	afterRenderEffect,
	Component,
	input,
	model,
	output,
	viewChild,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { injectBodyLock } from '@valk-nx/helpers/lib/body-lock/body-lock.service';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: 'vp-panel',
	templateUrl: './panel.html',
	imports: [SVG_ICON_IMPORTS, TranslatePipe],
})
export class PanelComponent {
	label = input.required<string>();
	closeButton = input(true);

	open = model(false);
	closed = output();

	dialogRef = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

	private readonly bodyLock = injectBodyLock();

	constructor() {
		afterRenderEffect(() => {
			const dialog = this.dialogRef().nativeElement;
			const open = this.open();

			if (open && !dialog.open) {
				dialog.showModal();
			} else if (!open && dialog.open) {
				dialog.close();
			}

			this.bodyLock.toggle(open);
		});
	}

	close() {
		if (!this.open()) return;

		this.open.set(false);
		this.closed.emit();
	}

	onCancel(event: Event) {
		event.preventDefault();
		this.close();
	}
}
